<template>
  <div class="not-found-screen">
    <img class="not-found-screen__motif" src="../assets/images/login/img-bg.svg" alt="" aria-hidden="true" />
    <main class="not-found-screen__content">
        <h1>404 page not found</h1>
        <p>it seems you're in the wrong page</p>
        <button @click="home" class="btn btn--default" type="button">
          Take me home
        </button>
    </main>
  </div>
</template>

<script>
export default {
  name: "NotFoundComponent",
  methods: {
    home() {
      this.$router.push("/");
    },
  },
};
</script>
